import gestionDateBase from '@/services/general/gestionDateBase';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_DIVERS } from '@/configuration/catalogue/produitConf';
import store from '@/store/store';
import { REGIE } from '@/configuration/societe/societe';

export function initializeReferenceVentePartielle(devisCommande) {
  devisCommande.lignesCommande
    .filter(ligne => !!ligne.ligneReseau)
    .forEach((ligne) => {
      const ligneCmdSelProduit = ligne.ligneReseau.lignesCmdSelProduits
        ?.find(l => l.referenceVentePartielle);
      ligne.ligneReseau.referenceVentePartielle = ligneCmdSelProduit?.referenceVentePartielle;
    });
}

export default function initialize(devisCommande, sansIntervenantVide) {
  const societeActive = store.getters['societe/societeActive'];
  devisCommande.dateDevisCommande = gestionDateBase(devisCommande.dateDevisCommande);
  devisCommande.dateValidite = gestionDateBase(devisCommande.dateValidite);
  devisCommande.dateRenouvellement = gestionDateBase(devisCommande.dateRenouvellement);
  devisCommande.datePreavis = gestionDateBase(devisCommande.datePreavis);
  devisCommande.datePremierAffichage = gestionDateBase(devisCommande.datePremierAffichage);
  devisCommande.categorieVente = devisCommande.categorieVente
    ? devisCommande.categorieVente : CATEGORIE_DIVERS;
  initializeReferenceVentePartielle(devisCommande);
  devisCommande.lignesCommande.forEach((ligne) => {
    ligne.dateDebut = gestionDateBase(ligne.dateDebut);
    ligne.dateBatDemande = gestionDateBase(ligne.dateBatDemande);
    ligne.dateFin = gestionDateBase(ligne.dateFin);
    ligne.dateLivraison = gestionDateBase(ligne.dateLivraison);
    ligne.selectedLogistique = false;
    ligne.demandesLogistique = [];
    if (ligne.type === devisConf.REGROUPEMENT) {
      ligne.lignesCommande.forEach((ligneR) => {
        ligneR.decorator = {
          libelleRegroupement: ligne.libelle,
        };
      });
    }
    if (ligne.ligneCommandeDispositif?.nomenclature && typeof (ligne.ligneCommandeDispositif.nomenclature) === 'string') {
      ligne.ligneCommandeDispositif.nomenclature = JSON.parse(
        ligne.ligneCommandeDispositif.nomenclature);
    }
    if ((societeActive.roleParDefaut === REGIE && societeActive.roles.length === 1)
      || !ligne.lignesCommande) return;
    ligne.lignesCommande.forEach((ligneEnfant) => {
      ligneEnfant.libelleFournisseur = null;
    });
  });

  if (!sansIntervenantVide
    && (devisCommande.intervenants.length === 0
    || devisCommande.intervenants[devisCommande.intervenants.length - 1].tiersId)) {
    devisCommande.intervenants.push(genererIntervenant(devisCommande.id));
  }
  if (!devisCommande.repartitionsTva) {
    devisCommande.repartitionsTva = [];
  }
  if (devisCommande.echeanciers) {
    devisCommande.echeanciers.forEach((echeancier) => {
      echeancier.openEcheancierLignes = false;
      echeancier.select = false;
      echeancier.dateDebut = new Date(echeancier.dateDebut);
      echeancier.dateFin = new Date(echeancier.dateFin);
      if (echeancier.dateFinPremiereEcheance) {
        echeancier.dateFinPremiereEcheance = new Date(echeancier.dateFinPremiereEcheance);
      }
      echeancier.echeancierLignes.forEach((echeancierLigne) => {
        echeancierLigne.dateDebut = new Date(echeancierLigne.dateDebut);
        echeancierLigne.dateFin = new Date(echeancierLigne.dateFin);
        echeancierLigne.datePrevisionnelleFacturation = new Date(
          echeancierLigne.datePrevisionnelleFacturation,
        );
      });
    });
  }
  if (devisCommande.type === devisConf.TYPE_COMMANDE
    && devisCommande.notUpdateDatePreavis === undefined) {
    devisCommande.notUpdateDatePreavis = !!(devisCommande.id);
  }
  if (devisCommande?.etatSuivis) {
    devisCommande.etatSuivis.forEach((item) => {
      if (item.date) item.date = new Date(item.date);
    });
  }
  if (devisCommande.dateTransmissionAuClub) {
    devisCommande.dateTransmissionAuClub = new Date(devisCommande.dateTransmissionAuClub);
  }
  if (devisCommande.dateTransmissionAuClient) {
    devisCommande.dateTransmissionAuClient = new Date(devisCommande.dateTransmissionAuClient);
  }
  if (devisCommande.dateIndexationReference) {
    devisCommande.dateIndexationReference = new Date(devisCommande.dateIndexationReference);
  }
  if (devisCommande.dateDerniereIndexation) {
    devisCommande.dateDerniereIndexation = new Date(devisCommande.dateDerniereIndexation);
  }
}
